export const rTree = {
  id: 'root',
  name: 'R Package',
  link: 'https://simonscmap.github.io/cmap4r/index.html',
  children: [
    {
      id: '1',
      name: 'Getting Started',
      link: 'https://simonscmap.github.io/cmap4r/getting-started.html',
      children: [
        {
          id: '1.1',
          name: 'Obtaining and Saving API Key',
          link: 'https://simonscmap.github.io/cmap4r/getting-started.html#obtaining-and-saving-api-key',
        },
        {
          id: '1.2',
          name: 'Installation and Setup',
          link: 'https://simonscmap.github.io/cmap4r/getting-started.html#installation-and-setup',
        },
        {
          id: '1.3',
          name: 'Catalog of Data',
          link: 'https://simonscmap.github.io/cmap4r/getting-started.html#catalog-of-data',
        },
      ],
    },
    {
      id: '2',
      name: 'Data Retrieval',
      link: 'https://simonscmap.github.io/cmap4r/data-retrieval.html',
      children: [
        {
          id: '2.1',
          name: 'Obtaining Data Summaries',
          link: 'https://simonscmap.github.io/cmap4r/data-retrieval.html#obtaining-data-summaries',
        },
        {
          id: '2.2',
          name: 'Cruises',
          link: 'https://simonscmap.github.io/cmap4r/data-retrieval.html#cruises',
        },
        {
          id: '2.3',
          name: 'Download Data',
          link: 'https://simonscmap.github.io/cmap4r/data-retrieval.html#download-data',
        },
        {
          id: '2.4',
          name: 'Colocalize Data',
          link: 'https://simonscmap.github.io/cmap4r/data-retrieval.html#colocalize-data',
        },
        {
          id: '2.5',
          name: 'Issue SQL Query',
          link: 'https://simonscmap.github.io/cmap4r/data-retrieval.html#issue-sql-query',
        },
      ],
    },
    {
      id: '3',
      name: 'Visualization',
      link: 'https://simonscmap.github.io/cmap4r/visualization.html',
      children: [
        {
          id: '3.1',
          name: 'Regional Map',
          link: 'https://simonscmap.github.io/cmap4r/visualization.html#regional-map',
        },
        {
          id: '3.2',
          name: 'Time Series Plot',
          link: 'https://simonscmap.github.io/cmap4r/visualization.html#time-series-plot',
        },
        {
          id: '3.3',
          name: 'Depth Profile Plot',
          link: 'https://simonscmap.github.io/cmap4r/visualization.html#depth-profile-plot',
        },
        {
          id: '3.4',
          name: 'XY Plot',
          link: 'https://simonscmap.github.io/cmap4r/visualization.html#xy-plot',
        },
        {
          id: '3.5',
          name: 'Histograms',
          link: 'https://simonscmap.github.io/cmap4r/visualization.html#histograms',
        },
      ],
    },
    {
      id: '4',
      name: 'FAQ',
      link: 'https://simonscmap.github.io/cmap4r/faq.html',
    },
    {
      id: '5',
      name: 'Examples',
      link: 'https://simonscmap.github.io/cmap4r/examples.html',
      children: [
        {
          id: '5.1',
          name: 'Compare in-situ to remote data',
          link: 'https://simonscmap.github.io/cmap4r/examples.html#compare-in-situ-on-site-sunlight-data-to-remote-sensing-satellite-data.',
        },
      ],
    },
  ],
};
